export const Home = {
    href: '/',
    translation: {
        id: 'home'
    }
};
